import { IAuthUserContext } from '../../types/authUser';

// Default data for init of context
const authUserContextDefault: IAuthUserContext = {
  authUser: null,
  isError: false,
  hasCapability: () => true,
  hasService: () => true,
};

export default authUserContextDefault;
